<template>
  <div>
    <gmap-map :zoom="14" :center="center" style="width: 60%; height: 400px;">
      <gmap-marker
        :key="index"
        :animation="ani"
        v-for="(m, index) in locationMarkers"
        :position="m.position"
        @click="center = m.position"
      ></gmap-marker>
    </gmap-map>
  </div>
</template>
<script>
var seoul = { lat: 37.5642135, lng: 127.0016985 };
var seoul2 = { lat: 38.5642145, lng: 127.0016975 };
export default {
  name: "AddGoogleMap",
  data() {
    return {
      ani: 1,
      center: seoul,
      locationMarkers: [{ position: seoul }],

      locPlaces: [],
      existingPlace: null,
    };
  },
};
</script>
